import React, { useEffect, useState, useRef } from 'react';
import { Card, Container, Placeholder, Accordion, Form, Row, Col } from 'react-bootstrap';
import './NewsHeader.css';
import { getSop } from '../../service/ApiService';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

const SopSection: React.FC = () => {
    const [sop, setSop] = useState<any[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [categories, setCategories] = useState<string[]>([]);
    const [category, setCategory] = useState<string>("");

    const sopRef = useRef<HTMLDivElement>(null);

    const scrollToTop = () => {
        if (sopRef.current) {
            sopRef.current.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }

    const getSopFeed = async () => {
        const sopArray = await getSop()
        setSop(sopArray);
    };

    useEffect(() => {
        getSopFeed();
    }, []);

    useEffect(() => {
        if (data.length && categories.length < 1) {
            const categories = Array.from(
                new Set(data.map((item: any) => item.content))
            );
            setCategories(categories)
        }

    }, [data]);

    useEffect(() => {
        if (sop.length) {
            setData(sop);
        }
    }, [sop]);

    useEffect(() => {
        filterSop();
        scrollToTop();
    }, [searchQuery, category]);

    const handleSearchQuery = (query: string) => {
        setSearchQuery(query);
    }

    const handleSelectCategory = (category: string) => {
        setCategory(category)

    }

    const filterSop = () => {
        const filteredSop = sop.filter((item: any) => {

            const titleMatch = searchQuery
                ? item.title.toLowerCase().includes(searchQuery.toLowerCase())
                : true;

            const categoryMatch = category
                ? item.content?.toLowerCase() === category.toLowerCase()
                : true;

            return titleMatch && categoryMatch;

        })
        setData(filteredSop)

    }


    return (
        <Container className="header">
            <h5 className="text-center mb-2" style={{ color: 'black' }}>
                SOP, Memos and Design Directives
            </h5>
            {sop.length > 0 && (
                <Accordion className="mb-3">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Filters</Accordion.Header>
                        <Accordion.Body>
                            <Row className="mb-3">
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label htmlFor="filterSop" className="filter-form-label">
                                            Search
                                        </Form.Label>
                                        <Form.Control className="rounded-pill"
                                            id="filterSop" type="text" onChange={(e) => handleSearchQuery(e.currentTarget.value)} value={searchQuery} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            {categories.length > 0 && (
                                <Row>
                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label htmlFor="filterCategory" className="filter-form-label">
                                                Select category
                                            </Form.Label>
                                            <Form.Select
                                                className="rounded-pill"
                                                id="filterCategory"
                                                onChange={(e) => handleSelectCategory(e.currentTarget.value)}
                                                value={category}
                                            >
                                                <option value="">All categories</option>
                                                {categories.map((cat, index) => (
                                                    <option key={index} value={cat.toLowerCase()}>{cat}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )}

                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            )}
            <div className="news-container" ref={sopRef}>
                {sop.length > 0 ? (
                    data.map((item, index) => (
                        <Card key={index} className="news-card">
                            <Card.Body className="d-flex flex-column">
                                <small className="text-muted">{moment(item.date).format('MMM DD, YYYY')}</small>
                                <Card.Title className="sop-header">{item.title}</Card.Title>
                                <Card.Text className="news-text">{item.content}</Card.Text>
                                <a className="btn btn-sm btn-primary mt-auto" href={item.url} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon
                                        icon={faExternalLinkAlt}
                                        className="me-2"
                                    />
                                    Read more
                                </a>
                            </Card.Body>
                        </Card>
                    ))
                ) : (
                    <div>
                        {Array.from({ length: 3 }).map((_, index) => (
                            <div key={index}>
                                <Card className="communication-message p-2">
                                    <Card.Body >
                                        <Placeholder as={Card.Title} animation="wave">
                                            <Placeholder xs={12} size="xs" />
                                        </Placeholder>
                                        <Placeholder as={Card.Title} animation="wave">
                                            <Placeholder xs={12} size="sm" />
                                            <Placeholder xs={12} size="sm" />
                                        </Placeholder>
                                        <Placeholder className="mt-4" as={Card.Title} size="sm" animation="wave">
                                            <Placeholder xs={8} size="xs" />
                                        </Placeholder>
                                        <Placeholder.Button variant="success" xs={12} />
                                    </Card.Body>
                                </Card>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </Container>

    );
};

export default SopSection;
